import React, { Fragment } from "react";

class AppFooter extends React.Component {
  render() {
    return (
      <Fragment>
        <div className="app-footer">
          <div className="app-footer__inner" style={{ justifyContent: 'center', textAlign: 'center', width: '100%' }}>
            <span>© Copyright Growfin.tech</span>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default AppFooter;
